import { inject, Injectable } from '@angular/core';

import { BROWSER_WALLET_GLOBAL } from '@drf/core';

const SIWX_AUTH_TOKEN_KEY = '@appkit/siwx-auth-token';
const SIWX_NONCE_TOKEN_KEY = '@appkit/siwx-nonce-token';

@Injectable({ providedIn: 'root' })
export class WalletAuthSessionStorageService {
  readonly #browserGlobal = inject(BROWSER_WALLET_GLOBAL);

  /** Checks whether Reown has persisted a completed SIWX authentication session. */
  hasSiwxAuthToken(): boolean {
    try {
      const storage = this.#getStorage();
      const token = storage?.getItem(SIWX_AUTH_TOKEN_KEY);

      return typeof token === 'string' && token.trim().length > 0;
    } catch {
      return false;
    }
  }

  /** Removes Reown SIWX tokens when the local wallet session is cleared. */
  clearSiwxTokens(): void {
    try {
      const storage = this.#getStorage();
      storage?.removeItem(SIWX_AUTH_TOKEN_KEY);
      storage?.removeItem(SIWX_NONCE_TOKEN_KEY);
    } catch {
      return;
    }
  }

  /** Safely returns localStorage only when the required methods are available. */
  #getStorage(): Pick<Storage, 'getItem' | 'removeItem'> | null {
    const storage = this.#browserGlobal.localStorage;

    if (!storage || typeof storage.getItem !== 'function' || typeof storage.removeItem !== 'function') {
      return null;
    }

    return storage;
  }
}
